import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private toastr: ToastrService) {}

  success(message: string) {
    this.toastr.success(message, 'SUCCESS');
  }

  error(message: string) {
    this.toastr.error(message, 'ERROR');
  }

  warning(message: string) {
    this.toastr.warning(message, 'WARNING');
  }

  info(message: string) {
    this.toastr.info(message, 'INFO');
  }
}
